'use strict';

/**
 * @type {{init: jsBilling.init, initAjaxRequest: jsBilling.initAjaxRequest, initBillingDetailLinks: jsBilling.initBillingDetailLinks}}
 */
var jsBilling = {
    init: function () {
        jsBilling.initAjaxRequest();
        jsBilling.initBillingDetailLinks();
    },

    initAjaxRequest: function () {
        var $loadMoreItemsLink = $('.js-billing-load-items');
        var $loadMoreItemsLinkContainer = $('.js-billing-load-items-container');

        $loadMoreItemsLink.click(function () {
            $loadMoreItemsLinkContainer.find('.c-loading--dots').show();
            $loadMoreItemsLink.toggleClass('is-hidden', true);

            billingFilterData['page']++;

            $.ajax({
                type: 'POST',
                async: true,
                url: Routing.generate('_frontend_ajax_billing_get_items'),
                data: {
                    page: billingFilterData['page'],
                },
                success: function (response) {
                    $loadMoreItemsLinkContainer.find('.c-loading--dots').hide();

                    $('.js-billing-items-list').append(response.renderedBillingItems);

                    if (response.meta) {
                        billingFilterData['totalPages'] = response.meta.totalPages;
                    }

                    if (billingFilterData.page >= response.meta.totalPages) {
                        $loadMoreItemsLink.addClass('is-hidden');
                    } else {
                        $loadMoreItemsLink.removeClass('is-hidden');
                    }
                },
                error: function (xhr, status) {
                    $loadMoreItemsLinkContainer.find('.c-loading--dots').hide();
                    $loadMoreItemsLink.toggleClass('is-hidden', true);
                }
            });

            return false;
        });
    },

    initBillingDetailLinks: function () {
        var $billingItemModal = $('#js-modal-billing-item-detail');
        var $billingItemTitle = $billingItemModal.find('.js-billing-item-detail-title');
        var $billingItemBody = $billingItemModal.find('.js-billing-item-detail-body');

        $(document).on('click', '.js-billing-item-detail', function (event) {
            event.preventDefault();

            var billingItemId = $(this).data('id');
            var billingItemTitleText = $(this).data('title');

            var loadingMessage = Translator.trans('message.loadingBillingItemDetail', {}, 'billing');

            $billingItemModal.find($billingItemTitle).html(billingItemTitleText);
            $billingItemModal.find($billingItemBody).html(loadingMessage);
            $billingItemModal.modal('show');

            $.ajax({
                type: 'GET',
                async: true,
                url: Routing.generate('_frontend_ajax_billing_get_item'),
                data: {'billingItemId': billingItemId},
                success: function (response) {
                    $billingItemModal.find($billingItemBody).html(response);
                },
                error: function (xhr, status) {

                }
            });
        });
    }
};
